<script setup lang="ts">
import { computed } from 'vue'

interface Facets {
  services: Record<string, number>
  product_suites: Record<string, number>
}

const props = defineProps<{
  facets: Facets
  selectedServices: string[]
}>()

const emit = defineEmits<{
  (e: 'update:services', value: string[]): void
}>()

const sortedServices = computed(() => {
  return Object.entries(props.facets.services)
    .sort(([nameA], [nameB]) => nameA.localeCompare(nameB))
})

function toggleService(serviceName: string) {
  const newServices = props.selectedServices.includes(serviceName)
    ? props.selectedServices.filter(s => s !== serviceName)
    : [...props.selectedServices, serviceName]
  
  emit('update:services', newServices)
}

function isServiceSelected(serviceName: string): boolean {
  return props.selectedServices.includes(serviceName)
}
</script>

<template>
  <div>
    <h3 class="text-sm font-semibold text-gray-900 mb-3">
      Filter by Service
    </h3>
    
    <div class="space-y-2">
      <label
        v-for="[serviceName, count] in sortedServices"
        :key="serviceName"
        class="flex items-start cursor-pointer group"
      >
        <input
          type="checkbox"
          :checked="isServiceSelected(serviceName)"
          class="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          @change="toggleService(serviceName)"
        />
        <span class="ml-3 text-sm text-gray-700 group-hover:text-gray-900">
          {{ serviceName }}
          <span class="text-gray-500">({{ count }})</span>
        </span>
      </label>
    </div>
  </div>
</template>